module.exports = __webpack_public_path__ + "static/img/4en.3594057.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/4en.png
// module id = 6Qj+
// module chunks = 0